import { orbCore } from 'services/Orb/Service'
import { CommuniqueModel } from 'core/models/communique'

export const CommuniquesNotificationsService = {
  create: (payload) => orbCore.communiquesNotificationsDomain.create(CommuniqueModel.create(payload))
}
